import * as THREE from 'three';
import View from "../../src/Core/View";
import GeometryLayer from "../../src/Layer/GeometryLayer";
import { PNTS_SHAPE, PNTS_SIZE_MODE } from "../../src/Renderer/PointsMaterial";
import GeometryDebug from "./GeometryDebug";
import OBBHelper from "./OBBHelper";
var bboxMesh = new THREE.Mesh();
export default function create3dTilesDebugUI(datDebugTool, view, _3dTileslayer) {
  var gui = GeometryDebug.createGeometryDebugUI(datDebugTool, view, _3dTileslayer);
  var regionBoundingBoxParent = new THREE.Group();
  view.scene.add(regionBoundingBoxParent);

  // add wireframe
  GeometryDebug.addWireFrameCheckbox(gui, view, _3dTileslayer);

  // Bounding box control
  var obb_layer_id = "".concat(_3dTileslayer.id, "_obb_debug");
  var obbLayer = new GeometryLayer(obb_layer_id, new THREE.Object3D(), {
    update: function (context, layer, node) {
      var metadata = node.userData.metadata;
      var helper = node.userData.obb;
      if (!layer.visible) {
        if (helper) {
          helper.visible = false;
          if (typeof helper.setMaterialVisibility === 'function') {
            helper.setMaterialVisibility(false);
          }
        }
        return;
      }
      if (node.visible && metadata.boundingVolume) {
        if (!helper) {
          // 3dtiles with region
          if (metadata.boundingVolume.region) {
            helper = new OBBHelper(metadata.boundingVolume.region, "id:".concat(node.id));
            regionBoundingBoxParent.add(helper);
            helper.updateMatrixWorld(true);
            // 3dtiles with box
          } else if (metadata.boundingVolume.box) {
            bboxMesh.geometry.boundingBox = metadata.boundingVolume.box;
            helper = new THREE.BoxHelper(bboxMesh);
            helper.material.linewidth = 2;
            // 3dtiles with Sphere
          } else if (metadata.boundingVolume.sphere) {
            var geometry = new THREE.SphereGeometry(metadata.boundingVolume.sphere.radius, 32, 32);
            var material = new THREE.MeshBasicMaterial({
              wireframe: true
            });
            helper = new THREE.Mesh(geometry, material);
            helper.position.copy(metadata.boundingVolume.sphere.center);
          }
          if (helper) {
            helper.layer = layer;
            // add the ability to hide all the debug obj for one layer at once
            var l3js = layer.threejsLayer;
            helper.layers.set(l3js);
            if (helper.children.length) {
              helper.children[0].layers.set(l3js);
            }
            node.userData.obb = helper;
            helper.updateMatrixWorld();
          }
          if (helper && !metadata.boundingVolume.region) {
            // compensate B3dm orientation correction
            var gltfUpAxis = _3dTileslayer.tileset.asset.gltfUpAxis;
            if (gltfUpAxis === undefined || gltfUpAxis === 'Y') {
              helper.rotation.x = -Math.PI * 0.5;
            } else if (gltfUpAxis === 'X') {
              helper.rotation.z = -Math.PI * 0.5;
            }

            // Add helper to parent to apply the correct transformation
            node.parent.add(helper);
            helper.updateMatrix();
            helper.updateMatrixWorld(true);
          }
        }
        if (helper) {
          helper.visible = true;
          if (typeof helper.setMaterialVisibility === 'function') {
            helper.setMaterialVisibility(true);
          }
        }
      } else if (helper) {
        helper.visible = false;
        if (typeof helper.setMaterialVisibility === 'function') {
          helper.setMaterialVisibility(false);
        }
      }
    },
    visible: false,
    cacheLifeTime: Infinity,
    source: false
  });
  View.prototype.addLayer.call(view, obbLayer, _3dTileslayer).then(function (l) {
    gui.add(l, 'visible').name('Bounding boxes').onChange(function () {
      view.notifyChange(view.camera.camera3D);
    });
  });

  // The sse Threshold for each tile
  gui.add(_3dTileslayer, 'sseThreshold', 0, 100).name('sseThreshold').onChange(function () {
    view.notifyChange(view.camera.camera3D);
  });
  gui.add(_3dTileslayer, 'pntsShape', PNTS_SHAPE).name('Points Shape').onChange(function () {
    view.notifyChange(view.camera.camera3D);
  });
  gui.add(_3dTileslayer, 'pntsSizeMode', PNTS_SIZE_MODE).name('Pnts size mode').onChange(function () {
    view.notifyChange(view.camera.camera3D);
  });
  gui.add(_3dTileslayer, 'pntsMinAttenuatedSize', 0, 15).name('Min attenuated size').onChange(function () {
    view.notifyChange(view.camera.camera3D);
  });
  gui.add(_3dTileslayer, 'pntsMaxAttenuatedSize', 0, 15).name('Max attenuated size').onChange(function () {
    view.notifyChange(view.camera.camera3D);
  });
}